
import React, { useState, useEffect } from 'react';
//import { useAuth } from '../AuthContext';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../actions/authActions';
//import axios from 'axios';
//import { setDefaultAuthToken } from '../Api';
import logo from '../images/newlogo.jpg';
import boltwareLogo from '../images/boltware.png';
import loaderImage from '../images/loader.svg';
//import AuthContext from './context/AuthProvider';
import useAuth from '../context/useAuth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from '../api/axios';
import Modal from 'react-bootstrap/Modal';

const Login = () => {


    const { setAuth } = useAuth();

    //const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    let from = location.state?.from?.pathname || '/home';

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [auctionlocation, setAuctionLocation] = useState(0);
    const [tableNumber, setTableNumber] = useState(0);
    const [consent, setConsent] = useState(false);
    const [isForceLogin, setIsForceLogin] = useState(false);
    const [modalMessageVisible, setModalMessageVisible] = useState(false);

    useEffect(() => {
        const _savedLoc = localStorage.getItem('eAucSBLOC');
        const _savedTableNo = localStorage.getItem('eAucSBTNO');
        if (_savedLoc) {
            setAuctionLocation(_savedLoc.toString());
        }
        if (_savedTableNo) {
            setTableNumber(_savedTableNo.toString());
        }
    }, []);

    const handleModalMessageClose = () => {
        setModalMessageVisible(false);
    };

    const saveLoginInfo = async (location, tableNo) => {

        localStorage.removeItem('eAucSBLOC');
        localStorage.removeItem('eAucSBTNO');

        localStorage.setItem('eAucSBLOC', location);
        localStorage.setItem('eAucSBTNO', tableNo);
    }


    const initSendOTP = (mobileNumber) => {
        if (window.initSendOTP) {

            const configuration = {
                widgetId: "346776676c63363633373537",
                tokenAuth: "417707Tbd1GNd8Zp669e0804P1",
                identifier: `91${mobileNumber}`,
                exposeMethods: false,
                success: (data) => {
                    handleLoginWithOTP(isForceLogin, data?.message)
                },
                failure: (error) => {
                    console.log('failure reason', error);
                    console.log(error);
                },
                "OTP": "<OTP>"
            };

            window.initSendOTP(configuration);
        } else {
            console.error('OTP provider script is not loaded.');
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://control.msg91.com/app/assets/otp-provider/otp-provider.js";
        script.onload = () => console.log('OTP provider script loaded');
        script.onerror = () => console.error('Error loading OTP provider script');
        document.body.appendChild(script);

        // Cleanup script on unmount
        return () => {
            document.body.removeChild(script);
        };
    }, []);


    const handleLoginWithOTP = async (_forceLogin, _otpToken) => {
        if (username && password) {
            if (consent) {
                try {
                  //const response = await axios.post('https://localhost:44495/api/auth/loginwithotp', {
                   const response = await axios.post('https://eauctionspicesboard.in/api/auth/loginwithotp', {
                        userName: username,
                        password: password,
                        location: auctionlocation,
                        tableNumber: tableNumber,
                        consent: consent,
                        forceLogin: _forceLogin,
                        otpToken: _otpToken

                    }, {
                        headers: { 'Content-type': 'application/json' },
                        withCredentials: true
                    });

                    if (response?.data.isValidLogin && response?.data.success === false) {

                        if (response?.data.canSkipOTP === true) {
                            handleLogin(false)
                        }
                        else if (response?.data.mobileNumber !== "" && response?.data.mobileNumber.length === 10 && response?.data.canSkipOTP === false) {
                            initSendOTP(response?.data.mobileNumber);
                        }
                        else
                            alert("Login Denied. \nMobile number not updated with Spices Board. \nPlease contact Spices Board admin.")
                    }
                    else if (response?.data.success) {
                        const accessToken = response?.data?.accessToken;
                        const name = response?.data?.name;
                        const role = response?.data?.role;
                        const userId = response?.data?.userId;
                        const licenseNo = response?.data?.licenseNo;

                        setAuth({ userId, name, role, accessToken, licenseNo })
                        //setDefaultAuthToken(accessToken);

                        await saveLoginInfo(auctionlocation, tableNumber);

                        if (role === "Primary Auctioneer" || role === "Secondary Auctioneer" || role === "Support Auctioneer")
                            from = "/auctioneer";
                        else if (role === "Trader")
                            from = "/trader";
                        else if (role === "Streamer")
                            from = "/streamer";
                        else if (role === "Pooler")
                            from = "/pooling";

                        navigate(from, { replace: true });
                    }
                    else {

                        if (response?.data.message.toLowerCase().indexOf("already") > -1) {
                            if (window.confirm(response?.data.message)) {
                                setIsForceLogin(true);
                                handleLoginWithOTP(true,null);
                            }
                        } else
                            alert(response?.data.message);
                    }

                } catch (error) {

                    if (!error?.response)
                        console.error('No Server Response');
                    else if (!error?.response?.status === 400)
                        console.error('Missing Username or Password');
                    else if (!error?.response?.status === 401)
                        console.error('Unauthorized');
                    else {
                        alert("Login failed");
                    }
                }
            }
            else
                alert("Please agree to Terms of Use and Privacy Policy");
        }
        else
            alert("Please enter username and password");
    };

    const handleLogin = async (_forceLogin) => {

        if (username && password) {
            if (consent) {
                try {
                  //const response = await axios.post('https://localhost:44495/api/auth/login', {
                    //const response = await axios.post('http://3.108.215.54:8080/api/auth/login', {
                    const response = await axios.post('https://eauctionspicesboard.in/api/auth/login', {
                        userName: username,
                        password: password,
                        location: auctionlocation,
                        tableNumber: tableNumber,
                        consent: consent,
                        forceLogin: _forceLogin
                    }, {
                        headers: { 'Content-type': 'application/json' },
                        withCredentials: true
                    });
                    //console.log(response?.data);
                    if (response?.data.success) {
                        const accessToken = response?.data?.accessToken;
                        const name = response?.data?.name;
                        const role = response?.data?.role;
                        const userId = response?.data?.userId;
                        const licenseNo = response?.data?.licenseNo;
                        const mobileNumber = response?.data?.mobileNumber;

                        setAuth({ userId, name, role, accessToken, licenseNo, mobileNumber })
                        //setDefaultAuthToken(accessToken);

                        await saveLoginInfo(auctionlocation, tableNumber);

                        if (role === "Primary Auctioneer" || role === "Secondary Auctioneer" || role === "Support Auctioneer")
                            from = "/auctioneer";
                        else if (role === "Trader")
                            from = "/trader";
                        else if (role === "Streamer")
                            from = "/streamer";
                        else if (role === "Pooler")
                            from = "/pooling";

                        navigate(from, { replace: true });
                    }
                    else {

                        if (response?.data.message.toLowerCase().indexOf("already") > -1) {
                            if (window.confirm(response?.data.message)) {
                                setIsForceLogin(true);
                                handleLogin(true);
                            }
                        } else
                            alert(response?.data.message);
                    }

                } catch (error) {

                    if (!error?.response)
                        console.error('No Server Response');
                    else if (!error?.response?.status === 400)
                        console.error('Missing Username or Password');
                    else if (!error?.response?.status === 401)
                        console.error('Unauthorized');
                    else {
                        alert("Login failed");
                    }
                }
            }
            else
                alert("Please agree to Terms of Use and Privacy Policy");
        }
        else
            alert("Please enter username and password");
    };
    return (
        <div className="ltr main-body leftmenu error-1">
            {/*<div id="global-loader" >*/}
            {/*    <img src={loaderImage} className="loader-img" alt="Loader" />*/}
            {/*</div>*/}
            <div className="page main-signin-wrapper">
                <div className="d-flex header-setting-icon demo-icon fa-spin">
                </div>
                <div className="row signpages text-center">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="row row-sm">
                                <div className="col-lg-6 col-xl-5 d-none d-lg-block text-center  details">
                                    <div className="mt-5 pt-4 p-2 pos-absolute">

                                        <img src={logo} className="header-brand-img mb-4" style={{ maxWidth: "80%" }} alt="logo" />
                                        <div className="clearfix"></div>
                                        <h3 className="mt-4 text-primary" >eAuction System</h3>
                                        <div className="tx-13 mt-2 mt-xl-2">Contact Us</div>
                                        <div className="tx-13 mt-xl-0">Phone: 0484-2333610</div>
                                        <div className="tx-13 mt-xl-0">Email: marketing.sb-ker@gov.in</div>

                                        <div className="mt-5 d-flex flex-column justify-content-center">
                                            <div className="tx-13">Website Developed & maintained by </div>
                                            <div>  <img src={boltwareLogo} alt="boltware" style={{ width: "50%" }}></img></div>
                                            <a href="https://boltware.in" rel="noreferrer" className="tx-12" target="_blank">www.boltware.in</a>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form ">
                                    <div className="main-container container-fluid">
                                        <div className="row row-sm">
                                            <div className="card-body mt-2 mb-2">
                                                <img src={logo} className="d-lg-none header-brand-img text-start  mb-4 error-logo-light wd-70p mg-t-0 mg-r-auto mg-b-0 mg-l-auto" alt="logo" />
                                                <img src={logo} className=" d-lg-none header-brand-img text-start mb-4 error-logo wd-70p mg-t-0 mg-r-auto mg-b-0 mg-l-auto" alt="logo" />
                                                <div className="clearfix"></div>
                                                <form>
                                                    <h5 className="text-start mb-2">Signin to Your Account</h5>
                                                    {/*<p className="mb-4 text-muted tx-13 ms-0 text-start">Signin to create, discover and connect with the global community</p>*/}
                                                    <div className="form-group text-start">
                                                        {/*<label>User Code</label>*/}
                                                        <input className="form-control" placeholder="User Code" type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
                                                    </div>
                                                    <div className="form-group text-start">
                                                        {/*<label>Location</label>*/}
                                                        <select className="form-control" placeholder="Select location" value={auctionlocation} onChange={(e) => setAuctionLocation(e.target.value)} >
                                                            <option value="">Select location</option>
                                                            <option value="1">Puttady</option>
                                                            <option value="2">Bodinayakanur</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group text-start">
                                                        {/*<label>Table Number</label>*/}
                                                        <select className="form-control" placeholder="Select table number" value={tableNumber} onChange={(e) => setTableNumber(e.target.value)} >
                                                            <option value="">Select table number</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                            <option value="13">13</option>
                                                            <option value="14">14</option>
                                                            <option value="15">15</option>
                                                            <option value="16">16</option>
                                                            <option value="17">17</option>
                                                            <option value="18">18</option>
                                                            <option value="19">19</option>
                                                            <option value="20">20</option>
                                                            <option value="21">21</option>
                                                            <option value="22">22</option>
                                                            <option value="23">23</option>
                                                            <option value="24">24</option>
                                                            <option value="25">25</option>
                                                            <option value="26">26</option>
                                                            <option value="27">27</option>
                                                            <option value="28">28</option>
                                                            <option value="29">29</option>
                                                            <option value="30">30</option>
                                                            <option value="31">31</option>
                                                            <option value="32">32</option>
                                                            <option value="33">33</option>
                                                            <option value="34">34</option>
                                                            <option value="35">35</option>
                                                            <option value="36">36</option>
                                                            <option value="37">37</option>
                                                            <option value="38">38</option>
                                                            <option value="39">39</option>
                                                            <option value="40">40</option>
                                                            <option value="41">41</option>
                                                            <option value="42">42</option>
                                                            <option value="43">43</option>
                                                            <option value="44">44</option>
                                                            <option value="45">45</option>
                                                            <option value="46">46</option>
                                                            <option value="47">47</option>
                                                            <option value="48">48</option>
                                                            <option value="49">49</option>
                                                            <option value="50">50</option>
                                                            <option value="51">51</option>
                                                            <option value="52">52</option>
                                                            <option value="53">53</option>
                                                            <option value="54">54</option>
                                                            <option value="55">55</option>
                                                            <option value="56">56</option>
                                                            <option value="57">57</option>
                                                            <option value="58">58</option>
                                                            <option value="59">59</option>
                                                            <option value="60">60</option>
                                                            <option value="61">61</option>
                                                            <option value="62">62</option>
                                                            <option value="63">63</option>
                                                            <option value="64">64</option>
                                                            <option value="65">65</option>
                                                            <option value="66">66</option>
                                                            <option value="67">67</option>
                                                            <option value="68">68</option>
                                                            <option value="69">69</option>
                                                            <option value="70">70</option>
                                                            <option value="71">71</option>
                                                            <option value="72">72</option>
                                                            <option value="73">73</option>
                                                            <option value="74">74</option>
                                                            <option value="75">75</option>
                                                            <option value="76">76</option>
                                                            <option value="77">77</option>
                                                            <option value="78">78</option>
                                                            <option value="79">79</option>
                                                            <option value="80">80</option>
                                                            <option value="81">81</option>
                                                            <option value="82">82</option>
                                                            <option value="83">83</option>
                                                            <option value="84">84</option>
                                                            <option value="85">85</option>
                                                            <option value="86">86</option>
                                                            <option value="87">87</option>
                                                            <option value="88">88</option>
                                                            <option value="89">89</option>
                                                            <option value="90">90</option>
                                                            <option value="91">91</option>
                                                            <option value="92">92</option>
                                                            <option value="93">93</option>
                                                            <option value="94">94</option>
                                                            <option value="95">95</option>
                                                            <option value="96">96</option>
                                                            <option value="97">97</option>
                                                            <option value="98">98</option>
                                                            <option value="99">99</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group text-start">
                                                        {/*<label>Password</label>*/}
                                                        <input className="form-control" placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                                    </div>
                                                    <div className="form-group text-start d-flex flex-row align-items-start">
                                                        <input type="checkbox" className="mt-2" checked={consent} onChange={(e) => setConsent(!consent)} ></input>
                                                        <label className="mg-l-6">I have read, understand and accept the <br></br> <a href="/terms-of-use" className="custom-link" target="_blank"> Terms of Use</a> and <a href="privacy-policy" className="custom-link" target="_blank"> Privacy Policy</a>
                                                        </label>
                                                    </div>
                                                    <input type="button" value="Sign In" className="btn ripple btn-main-primary btn-block" onClick={() => handleLogin(false,null)}></input>
                                                </form>
                                                
                                                {/*SHRAVAN V2 <div className="text-start mt-2 ms-0">*/}
                                                {/*    <div className="mb-1 d-flex justify-content-between">*/}
                                                {/*        <a href="forgot-password">Forgot password?</a>*/}
                                                {/*        <a href="poolings" className="highlight-light">View Upcoming Auctions</a>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </div> </div>
                                    </div>

                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div className="main-navbar-backdrop"></div>

            <Modal show={modalMessageVisible} >
                <Modal.Header closeButton onClick={handleModalMessageClose}>
                    <Modal.Title className="d-flex align-items-center"> <i className="fe fe-info fs-1 text-warning me-2"></i> Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div >

                        <p className="mb-1">Starting from 22nd August 2024, all logins will require OTP-based authentication. The OTP will be sent to the mobile number registered with your license.</p>
                        <p className="mb-1">You can view your license details in the profile section.</p>
                    </div>
                   
                    <div className="mt-3">
                        <button className="btn ripple btn-light pd-x-30" onClick={handleModalMessageClose}>
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Login;

